module.exports = "<div seedelement><span class=\"lui-status__text\"><slot></slot></span></div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-status/theme/lui-status.html
// module id = 326
// module chunks = 0 1 25